export enum SalaryType {

  PAID = "PAID",
  UNPAID = "UNPAID",
  VOLUNTEER_PAID = "VOLUNTEER_PAID",
  VOLUNTEER_UNPAID = "VOLUNTEER_UNPAID"

}
